module.exports = __webpack_public_path__ + "media/images/facebook-9cc2f4a76be1558a4488d2742d1719e7.svg";